import React from "react";

export default function BirthdayFrame5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 1500"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-5bi1{fill:#ffb84c}.cls-5bi3{fill:#8b46bc}.cls-5bi4{fill:#b56aea}.cls-5bi6{fill:#e05151}.cls-5bi8{fill:#ffbd66}.cls-5bi9{fill:#f88}.cls-5bi10{fill:#f16767}.cls-5bi11{fill:#a459d1}"
            }
          </style>
        </defs>
        <path
          d="M1087.94 1206.52h-771.7c-35.05 0-63.57-28.52-63.57-63.57v-771.7c0-35.05 28.52-63.57 63.57-63.57h771.7c35.05 0 63.57 28.52 63.57 63.57v771.7c0 35.05-28.52 63.57-63.57 63.57Zm-771.7-879.83c-24.58 0-44.57 19.99-44.57 44.57v771.7c0 24.58 19.99 44.57 44.57 44.57h771.7c24.58 0 44.57-19.99 44.57-44.57V371.25c0-24.58-19.99-44.57-44.57-44.57h-771.7Z"
          className="cls-5bi1"
        />
        <path
          d="M1049.04 1156.67h-693.9c-29.01 0-52.62-23.6-52.62-52.62V410.16c0-29.01 23.6-52.62 52.62-52.62h693.89c29.01 0 52.62 23.6 52.62 52.62v693.89c0 29.01-23.6 52.62-52.62 52.62Zm-693.9-791.13c-24.6 0-44.62 20.02-44.62 44.62v693.89c0 24.6 20.02 44.62 44.62 44.62h693.89c24.6 0 44.62-20.02 44.62-44.62V410.16c0-24.6-20.02-44.62-44.62-44.62H355.14Z"
          className="cls-5bi10"
        />
        <path
          d="m186.24 283.585 142.395-51.406 54.316 150.456-142.395 51.406z"
          className="cls-5bi10"
        />
        <path
          d="m404.8 347.16-21.83 35.43-54.33-150.45 21.83-35.43 54.33 150.45z"
          className="cls-5bi6"
        />
        <path
          d="m350.47 196.71-142.39 51.41-21.83 35.44 142.39-51.42 21.83-35.43z"
          className="cls-5bi9"
        />
        <path
          d="m344.44 206-142.05 51.29-7.13 11.37 142.05-51.29 7.13-11.37z"
          className="cls-5bi4"
        />
        <path
          d="m245.469 262.19 15.97-5.766 54.317 150.456-15.971 5.765z"
          className="cls-5bi11"
        />
        <path
          d="m398.76 356.45-7.04 11.62-54.33-150.45 7.05-11.62 54.32 150.45z"
          className="cls-5bi3"
        />
        <path
          d="m286.67 219.74-15.96 5.77-25.23 36.66 15.97-5.77 25.22-36.66z"
          className="cls-5bi4"
        />
        <path
          d="M266.08 240.96s-19.5 4.99-35.26-10.39c-15.76-15.37-8.27-39.64 4.91-32.87 13.18 6.77 30.35 43.25 30.35 43.25Z"
          className="cls-5bi4"
        />
        <path
          d="M265.75 241.07s-12.94 3.14-23.92-8.58c-10.98-11.72-6.61-29.36 2.41-24.03 9.02 5.33 21.51 32.61 21.51 32.61Z"
          className="cls-5bi11"
        />
        <path
          d="M283.96 199.52c3.72 12.19-2.54 23.49-6.35 30.36-3.69 6.65-7.95 10.68-10.85 12.97-1.9-4.57-23.05-56.03-13.19-64.79 6.3-5.6 25.63 5.91 30.38 21.46Z"
          className="cls-5bi4"
        />
        <path
          d="M275.45 217.67c2.09 6.84-1.43 13.18-3.56 17.04-2.07 3.74-4.46 6-6.09 7.28-1.07-2.56-12.94-31.45-7.4-36.37 3.54-3.14 14.39 3.32 17.06 12.05Z"
          className="cls-5bi11"
        />
        <path
          d="m1084.65 938.563 160.042 41.479-33.574 129.54-160.042-41.48z"
          className="cls-5bi1"
        />
        <path
          d="m1251.05 1097.46-39.87 12.07 33.56-129.54 39.87-12.06-33.56 129.53z"
          style={{
            fill: "#ea9c36",
          }}
        />
        <path
          d="m1284.61 967.93-160.04-41.47-39.87 12.06 160.04 41.47 39.87-12.06z"
          style={{
            fill: "#ffbe69",
          }}
        />
        <path
          d="m1273.87 970.93-159.65-41.37-12.91 3.8 159.65 41.37 12.91-3.8z"
          className="cls-5bi9"
        />
        <path
          d="m1151.226 955.81 17.947 4.652-33.573 129.54-17.947-4.651z"
          className="cls-5bi10"
        />
        <path
          d="m1240.3 1100.47-12.96 4.01 33.57-129.54 12.96-4.01-33.57 129.54z"
          className="cls-5bi6"
        />
        <path
          d="m1212.91 949.35-17.95-4.66-43.68 11.08 17.94 4.65 43.69-11.07z"
          className="cls-5bi10"
        />
        <path
          d="M1182.09 952.56s-20.78-7.05-26.77-25.73c-5.99-18.67 14.42-30.91 22.82-19.36s3.95 45.09 3.95 45.09Z"
          className="cls-5bi9"
        />
        <path
          d="M1181.72 952.46s-13.69-4.79-17.3-18.48c-3.61-13.69 10.23-23.15 15.59-14.78 5.36 8.37 1.71 33.26 1.71 33.26Z"
          className="cls-5bi10"
        />
        <path
          d="M1221.65 934.37c-3.35 10.13-15.41 14.35-22.75 16.92a51.546 51.546 0 0 1-17.23 2.89c.79-4.07 9.9-49.74 23.88-50.34 8.93-.39 20.37 17.6 16.1 30.53Z"
          className="cls-5bi9"
        />
        <path
          d="M1203.7 941.98c-1.88 5.69-8.65 8.06-12.77 9.5a29.31 29.31 0 0 1-9.67 1.63c.44-2.28 5.56-27.92 13.4-28.26 5.01-.22 11.44 9.88 9.04 17.14Z"
          className="cls-5bi10"
        />
        <path
          d="m895.157 1119.674 218.964-41.65 31.317 164.638-218.964 41.65z"
          className="cls-5bi11"
        />
        <path
          d="m1187.54 1206.94-42.03 35.63-31.33-164.63 42.03-35.64 31.33 164.64z"
          className="cls-5bi3"
        />
        <path
          d="m1156.21 1042.3-218.96 41.66-42.03 35.64 218.96-41.66 42.03-35.64z"
          className="cls-5bi4"
        />
        <path
          d="m1144.75 1051.62-218.43 41.56-13.67 11.43 218.43-41.57 13.67-11.42zM986.25 1102.357l24.55-4.67 31.317 164.638-24.55 4.67z"
          className="cls-5bi1"
        />
        <path
          d="m1176.07 1216.26-13.61 11.69-31.33-164.64 13.62-11.69 31.32 164.64z"
          style={{
            fill: "#eaa03d",
          }}
        />
        <path
          d="m1058.11 1060.97-24.56 4.67-47.25 36.63 24.56-4.67 47.25-36.63z"
          className="cls-5bi8"
        />
        <path
          d="M1022.21 1081.62s-29.36 3.53-47.12-14.22c-17.77-17.75.36-42.83 17.1-34.45 16.73 8.39 30.03 48.67 30.03 48.67Z"
          className="cls-5bi8"
        />
        <path
          d="M1021.7 1081.71s-19.43 2.16-31.49-11.28c-12.06-13.44-.42-31.77 10.81-25.29s20.68 36.56 20.68 36.56Z"
          className="cls-5bi1"
        />
        <path
          d="M1060.44 1039.25c1.57 13.28-10.83 24.7-18.38 31.65-7.31 6.73-14.62 10.62-19.46 12.79-1.31-5.02-15.69-61.56 1.07-69.97 10.71-5.37 34.76 8.59 36.77 25.54Z"
          className="cls-5bi8"
        />
        <path
          d="M1042.73 1057.74c.88 7.45-6.08 13.87-10.32 17.77-4.1 3.78-8.21 5.96-10.93 7.18-.74-2.82-8.81-34.56.6-39.28 6.01-3.02 19.51 4.83 20.64 14.34Z"
          className="cls-5bi1"
        />
        <path
          d="m1180.03 796.75-14.43-8.32c2.15-3.12 4.92-7.94 6.74-14.32a49.226 49.226 0 0 0 1.59-18.69c4.81 2.77 9.62 5.55 14.43 8.32.24 4.61.06 11.46-2.25 19.31a57.476 57.476 0 0 1-6.08 13.71Z"
          className="cls-5bi10"
        />
        <path
          d="m186.11 467.16-14.43-8.32c2.15-3.12 4.92-7.94 6.74-14.32a49.226 49.226 0 0 0 1.59-18.69c4.81 2.77 9.62 5.55 14.43 8.32.24 4.61.06 11.46-2.25 19.31a57.476 57.476 0 0 1-6.08 13.71Z"
          className="cls-5bi11"
        />
        <path
          d="m168.59 328.97 9.8-.18c-.26-2.14-.39-5.29.42-8.96.99-4.5 2.94-7.79 4.3-9.72l-9.8.18a31.453 31.453 0 0 0-4.12 10.2c-.7 3.33-.74 6.26-.59 8.47Z"
          className="cls-5bi1"
        />
        <path
          d="m382.68 271.6 9.8-.18c-.26-2.14-.39-5.29.42-8.96.99-4.5 2.94-7.79 4.3-9.72l-9.8.18a31.453 31.453 0 0 0-4.12 10.2c-.7 3.33-.74 6.26-.59 8.47Z"
          className="cls-5bi10"
        />
        <path
          d="m202.96 143.18 5.83-3.1c-.81-1.21-1.85-3.06-2.49-5.51a18.11 18.11 0 0 1-.39-7.15c-1.94 1.03-3.89 2.07-5.83 3.1-.16 1.76-.17 4.38.64 7.39.6 2.22 1.47 3.99 2.23 5.27Z"
          className="cls-5bi1"
        />
        <path
          d="m278.34 158.84 7.82-.68c-.1-2.1-.04-5.2.79-8.86 1.02-4.49 2.74-7.84 3.92-9.81-2.61.23-5.21.45-7.82.68a39.726 39.726 0 0 0-3.81 10.28 38.43 38.43 0 0 0-.9 8.39ZM188.8 209.23l-9.11 4.02c-.75-2.14-2.09-5.18-4.53-8.31a29.337 29.337 0 0 0-8.46-7.37c3.04-1.34 6.08-2.68 9.11-4.02 2.31 1.51 5.55 4.02 8.52 7.91 2.19 2.86 3.58 5.62 4.46 7.77ZM1304.81 885.49l-16.56 1.78c-.11-3.79-.7-9.31-3-15.54-2.81-7.64-6.95-12.97-9.73-16.04 5.52-.59 11.04-1.19 16.56-1.78a57.445 57.445 0 0 1 12.73 31.58Z"
          className="cls-5bi10"
        />
        <path
          d="m1264.72 748.37-14.08 1.51c-.09-3.22-.6-7.92-2.55-13.21a41.755 41.755 0 0 0-8.28-13.64c4.69-.5 9.39-1.01 14.08-1.51a49.21 49.21 0 0 1 8.13 14.39c1.73 4.82 2.42 9.15 2.69 12.46Z"
          className="cls-5bi1"
        />
        <path
          d="m1040.28 1316.04-8.43-6.24c1.57-1.8 3.65-4.61 5.24-8.47 1.96-4.74 2.32-8.97 2.34-11.58l8.43 6.24c-.18 2.9-.79 7.17-2.8 11.91-1.48 3.49-3.27 6.2-4.79 8.14Z"
          className="cls-5bi10"
        />
        <path
          d="m1095.91 1340.27 8 10.64c-2.56 1.63-6.11 4.3-9.44 8.42a39.298 39.298 0 0 0-7.03 13.25c-2.67-3.55-5.34-7.1-8-10.64 1.27-3.47 3.55-8.45 7.7-13.49 3.06-3.71 6.22-6.36 8.76-8.18ZM1239.49 832.61l-8.43-6.24c1.57-1.8 3.65-4.61 5.24-8.47 1.96-4.74 2.32-8.97 2.34-11.58l8.43 6.24c-.18 2.9-.79 7.17-2.8 11.91-1.48 3.49-3.27 6.2-4.79 8.14ZM1290.17 1182.25l-10.22 1.1c-.07-2.34-.43-5.75-1.85-9.59-1.74-4.72-4.29-8-6.01-9.9 3.41-.37 6.81-.73 10.22-1.1 1.8 2.21 4.2 5.69 5.9 10.44 1.25 3.5 1.76 6.64 1.96 9.04ZM386.58 201.62l-16.56 1.78c-.11-3.79-.7-9.31-3-15.54-2.81-7.64-6.95-12.97-9.73-16.04 5.52-.59 11.04-1.19 16.56-1.78a57.445 57.445 0 0 1 12.73 31.58Z"
          className="cls-5bi11"
        />
        <path
          d="m1168.25 1299.14-16.56 1.78c-.11-3.79-.7-9.31-3-15.54-2.81-7.64-6.95-12.97-9.73-16.04 5.52-.59 11.04-1.19 16.56-1.78a57.445 57.445 0 0 1 12.73 31.58Z"
          className="cls-5bi1"
        />
        <path
          d="m1317.99 1127.35-12.27-11.26c2.77-2.58 6.53-6.68 9.69-12.51a49.312 49.312 0 0 0 5.62-17.9c4.09 3.75 8.18 7.51 12.27 11.26-.76 4.56-2.44 11.2-6.4 18.36-2.91 5.27-6.2 9.25-8.91 12.06Z"
          className="cls-5bi10"
        />
        <path
          d="m936.9 1363.81-16.56 1.78c-.11-3.79-.7-9.31-3-15.54-2.81-7.64-6.95-12.97-9.73-16.04 5.52-.59 11.04-1.19 16.56-1.78a57.445 57.445 0 0 1 12.73 31.58ZM1221.58 1160.9l-16.62 1.18c.03-3.79-.36-9.33-2.43-15.64a49.338 49.338 0 0 0-9.14-16.38c5.54-.39 11.08-.78 16.62-1.18 2.78 3.69 6.46 9.47 8.94 17.26a57.176 57.176 0 0 1 2.63 14.76Z"
          className="cls-5bi1"
        />
        <path
          d="m1220 1256.01-18.19-14.25c3.56-3.87 8.31-9.94 12.05-18.35a68.342 68.342 0 0 0 5.84-25.36c6.06 4.75 12.12 9.5 18.19 14.25-.57 6.38-2.16 15.75-6.86 26.07a79.695 79.695 0 0 1-11.02 17.63Z"
          className="cls-5bi10"
        />
        <path
          d="m893.04 1267.56-12.54-10.96c2.71-2.65 6.37-6.84 9.39-12.74 3.71-7.25 4.82-13.9 5.18-18.03 4.18 3.65 8.36 7.31 12.54 10.96a57.445 57.445 0 0 1-5.95 18.51 57.648 57.648 0 0 1-8.62 12.27Z"
          className="cls-5bi11"
        />
        <path
          d="M269.25 455.45c-4.17 0-7.97-.12-11.36-.3l.7-12.98c25.42 1.37 75.5-1.1 125.34-32.94 48.19-30.8 71.44-73.44 81-96.12l11.98 5.05c-10.15 24.07-34.82 69.34-85.98 102.03-46.25 29.56-92.7 35.27-121.68 35.27Z"
          className="cls-5bi1"
        />
        <path
          d="M269.24 451.11c9.46 16.54 18.92 33.09 28.37 49.63 7.73-18.78 15.46-37.55 23.18-56.33-5.35 2.59-12.19 5.22-20.32 6.8-12.8 2.49-23.72 1.4-31.23-.1ZM409.39 404.87c18.35 6.5 36.7 13.01 55.05 19.51l-20.43-57.39c-3.64 5.58-8.14 11.71-13.68 18.01a159.36 159.36 0 0 1-20.94 19.86Z"
          className="cls-5bi1"
        />
        <path
          d="M317.97 446.37c12.89 14.04 25.77 28.08 38.66 42.12l9.69-57.44c-5.3 2.55-11.2 5.08-17.7 7.39a179.019 179.019 0 0 1-30.65 7.93ZM444.17 368.83c18.89 2.55 37.77 5.11 56.66 7.66-9.76-16.79-19.52-33.57-29.28-50.36-2.44 5.35-5.37 11.07-8.88 17a177.759 177.759 0 0 1-18.5 25.69Z"
          className="cls-5bi10"
        />
        <path
          d="M366.32 430.74c15.72 10.78 31.43 21.56 47.15 32.34l-3.48-58.14a178.733 178.733 0 0 1-43.66 25.8Z"
          className="cls-5bi11"
        />
        {children}
      </g>
    </svg>
  );
}
